import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import './config/i18n'
import App from './App.tsx'
import { queryClient } from './lib/queryClient'
import { CurrencyProvider } from './contexts/CurrencyContext'
import { LanguageProvider } from './contexts/LanguageContext'
import { initializeZodI18n } from './lib/validators/zodErrorMap'
import { installDomMutationGuard } from './lib/domSafety'
import { QueryDevtools } from './components/dev/QueryDevtools'

// Keep a page translator (or any extension that rewrites text nodes) from turning a React
// commit into a fatal removeChild error. Must run before the first render.
installDomMutationGuard()

// Initialize Zod i18n error map
initializeZodI18n()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<div className="flex min-h-screen items-center justify-center text-muted-foreground">Loading...</div>}>
        <LanguageProvider>
          <CurrencyProvider>
            <App />
            {import.meta.env.DEV && <QueryDevtools />}
          </CurrencyProvider>
        </LanguageProvider>
      </Suspense>
    </QueryClientProvider>
  </StrictMode>,
)
